var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from '../KYC.module.css';
import { PageLayout } from '../../../Components/PageLayout';
import { FlexRow } from '../components/StyledKYCComponents';
import { InfoIcon } from '../components/Icons';
import Index from '../components/FileInput';
import { useCallback, useState } from 'react';
import { getVerificationToken, } from '../../../../Services/methods/verifications';
import { TooltipContent } from '../components/TooltipContent';
import { Tooltip } from '../../../Components/BaseComponents/Tooltip';
import { DOCS_SUB_TYPES, docTypeToView } from '../utils';
import { RemarksView } from '../components/ErrorsView';
var LoadDocuments = function (_a) {
    var currentDocType = _a.currentDocType, onNextClick = _a.onNextClick, onBackClick = _a.onBackClick, clientReviewResult = _a.clientReviewResult, countryCode = _a.countryCode, removeDocument = _a.removeDocument, loadDocument = _a.loadDocument, filesIds = _a.filesIds, onlyOneDocSide = _a.onlyOneDocSide, fileWarnings = _a.fileWarnings, fileErrors = _a.fileErrors, documentsLoaded = _a.documentsLoaded;
    var _b = useState(false), btnLoader = _b[0], setBtnLoader = _b[1];
    var _c = useState(), fetchTokenError = _c[0], setFetchTokenError = _c[1];
    var handleNextPageOpen = useCallback(function () {
        setBtnLoader(true);
        setFetchTokenError(undefined);
        getVerificationToken(countryCode)
            .then(function (res) {
            onNextClick(res.token);
        })
            .catch(function (res) {
            setFetchTokenError(res.message || 'Something went wrong');
        })
            .finally(function () {
            setBtnLoader(false);
        });
    }, [countryCode, onNextClick]);
    return (_jsx(PageLayout, __assign({ footer: {
            actionButtonLabel: 'Next',
            actionButtonDisable: !documentsLoaded || fileErrors.length !== 0,
            buttonClick: handleNextPageOpen,
            actionButtonLoader: btnLoader,
            actionBtnError: fetchTokenError,
        }, customBackClick: onBackClick }, { children: _jsxs(_Fragment, { children: [_jsx("h2", __assign({ className: styles.title }, { children: "Document verification" })), _jsxs(FlexRow, __assign({ style: { alignItems: 'baseline' } }, { children: [_jsx("p", __assign({ className: styles.text }, { children: "Photo of your ".concat(docTypeToView(currentDocType || '')) })), _jsx(Tooltip, __assign({ content: _jsx(TooltipContent, {}), width: "270px", position: "bottom" }, { children: _jsx(InfoIcon, {}) }))] })), _jsx(FlexRow, __assign({ style: { gap: '16px', alignItems: 'flex-start' } }, { children: (onlyOneDocSide ? [DOCS_SUB_TYPES[0]] : DOCS_SUB_TYPES).map(function (docSubType, index) {
                        var fileId = filesIds[index];
                        return (_jsx(Index, { name: docSubType, fileId: fileId, onDelete: removeDocument, loadDocument: loadDocument, reviewResult: fileId ? clientReviewResult.get("".concat(fileId)) : undefined }, docSubType));
                    }) })), _jsx(RemarksView, { list: fileErrors, type: "error" }), _jsx(RemarksView, { list: fileWarnings, type: "warning" })] }) })));
};
export default LoadDocuments;
